var map = {
	"./color.scss": [
		"2a44",
		"chunk-746df6da"
	],
	"./elements.scss": [
		"6117",
		"chunk-74907828"
	],
	"./global.scss": [
		"c860",
		"chunk-770dda5a"
	],
	"./savitarna.css": [
		"a77b",
		"chunk-74e31ab7"
	],
	"./savitarnaDevelop.css": [
		"aac2",
		"chunk-6b19a685"
	],
	"./savitarnaLocal.css": [
		"36b7",
		"chunk-46ed8124"
	],
	"./savitarnaProd.css": [
		"b881",
		"chunk-10acdbc5"
	],
	"./savitarnaTest.css": [
		"7679",
		"chunk-32c9bf37"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "96ac";
module.exports = webpackAsyncContext;